/** Prioridade da compra. Mesmos nomes e valores do enum do Compras no backend. */
export enum TipoPrioridadeEnum {
  Baixa = 1,
  Media = 2,
  Alta = 3,
}
